import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { ITrustedDomainsResponse } from '../models/trusted-domains.model';
import { fromTrustedDomainActions } from '../actions';

export const trustedDomainFeatureKey = 'trustedDomain';

export interface TrustedDomainState {
  loadTrustedDomainsResponse: ITrustedDomainsResponse[];
  loadTrustedDomainsFailure: IGenericError<ErrorResponse>;
}

export const initialState: TrustedDomainState = {
  loadTrustedDomainsResponse: undefined,
  loadTrustedDomainsFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(fromTrustedDomainActions.loadTrustedDomainsSuccess, (state, action) => ({
    ...state,
    loadTrustedDomainsResponse: action.response
  })),
  on(fromTrustedDomainActions.loadTrustedDomainsFailure, (state, action) => ({
    ...state,
    loadTrustedDomainsFailure: action.error
  }))
);

export const getTrustedDomainResponse = (state: TrustedDomainState) => state.loadTrustedDomainsResponse;
